module.exports = __webpack_public_path__ + "img/icon-filter.1dec08a6.svg";